module.exports = __webpack_public_path__ + "static/media/React_ToDo_List.8897aeb6.webp";